import styled from 'styled-components';


/*
========================================
PÁGINA
========================================
*/

export const PaginaNuevaCuenta =
    styled.div`

        min-height:
            100vh;

        background:
            #F7FAFA;

        color:
            #646464;

        box-sizing:
            border-box;

        *,
        *::before,
        *::after {
            box-sizing:
                border-box;
        }

    `;


/*
========================================
HEADER
========================================
*/

export const HeaderNuevaCuenta =
    styled.header`

        width:
            100%;

        min-height:
            76px;

        padding:
            14px 5%;

        display:
            flex;

        align-items:
            center;

        justify-content:
            space-between;

        gap:
            20px;

        background:
            #FFFFFF;

        border-bottom:
            1px solid
            rgba(
                35,
                170,
                175,
                0.15
            );

    `;


export const LogoLinkNuevaCuenta =
    styled.a`

        display:
            inline-flex;

        align-items:
            center;

        text-decoration:
            none;

    `;


export const LogoNuevaCuenta =
    styled.img`

        display:
            block;

        width:
            170px;

        height:
            auto;

        max-width:
            100%;

        object-fit:
            contain;

    `;


export const LinkLoginNuevaCuenta =
    styled.a`

        display:
            inline-flex;

        align-items:
            center;

        justify-content:
            center;

        min-height:
            42px;

        padding:
            0 20px;

        border:
            1.5px solid
            #23AAAF;

        border-radius:
            10px;

        color:
            #23AAAF;

        background:
            #FFFFFF;

        text-decoration:
            none;

        font-size:
            0.9rem;

        font-weight:
            700;

        transition:
            0.18s ease;

        &:hover {

            background:
                rgba(
                    35,
                    170,
                    175,
                    0.08
                );

        }


        @media (
            max-width:
                640px
        ) {

            display:
                none;

        }

    `;


/*
========================================
LAYOUT
========================================
*/

export const ContenedorNuevaCuenta =
    styled.main`

        width:
            min(
                1180px,
                calc(
                    100% - 40px
                )
            );

        margin:
            0 auto;

        padding:
            44px 0 70px;

        display:
            grid;

        grid-template-columns:
            minmax(
                280px,
                0.72fr
            )
            minmax(
                0,
                1.28fr
            );

        align-items:
            start;

        gap:
            30px;


        @media (
            max-width:
                900px
        ) {

            width:
                min(
                    760px,
                    calc(
                        100% - 28px
                    )
                );

            grid-template-columns:
                1fr;

            padding:
                28px 0 52px;

        }


        @media (
            max-width:
                520px
        ) {

            width:
                calc(
                    100% - 20px
                );

            padding-top:
                18px;

        }

    `;


/*
========================================
PANEL INTRODUCTORIO
========================================
*/

export const PanelNuevaCuenta =
    styled.aside`

        position:
            sticky;

        top:
            24px;

        padding:
            34px;

        overflow:
            hidden;

        border-radius:
            20px;

        background:
            rgba(
                35,
                170,
                175,
                0.10
            );

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.20
            );


        @media (
            max-width:
                900px
        ) {

            position:
                static;

            padding:
                28px;

        }


        @media (
            max-width:
                600px
        ) {

            display:
                none;

        }

    `;


export const EtiquetaPanel =
    styled.div`

        margin-bottom:
            12px;

        color:
            #655EE8;

        font-size:
            0.76rem;

        font-weight:
            800;

        letter-spacing:
            0.08em;

    `;


export const TituloPanel =
    styled.h1`

        margin:
            0;

        color:
            #23AAAF;

        font-size:
            clamp(
                1.7rem,
                3vw,
                2.35rem
            );

        line-height:
            1.12;

        font-weight:
            800;

    `;


export const TextoPanel =
    styled.p`

        margin:
            18px 0 0;

        max-width:
            430px;

        color:
            #646464;

        font-size:
            0.96rem;

        line-height:
            1.65;

    `;


export const ListaPanel =
    styled.div`

        margin-top:
            24px;

        display:
            flex;

        flex-direction:
            column;

        gap:
            10px;

    `;


export const ItemPanel =
    styled.div`

        color:
            #646464;

        font-size:
            0.9rem;

        font-weight:
            600;

    `;


export const IlustracionNuevaCuenta =
    styled.img`

        display:
            block;

        width:
            min(
                100%,
                290px
            );

        height:
            auto;

        margin:
            30px auto 0;

        object-fit:
            contain;

    `;


/*
========================================
TARJETA
========================================
*/

export const TarjetaNuevaCuenta =
    styled.section`

        width:
            100%;

        overflow:
            hidden;

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.22
            );

        border-radius:
            20px;

        background:
            #FFFFFF;

        box-shadow:
            0 10px 35px
            rgba(
                0,
                0,
                0,
                0.055
            );

    `;


export const EncabezadoFormulario =
    styled.div`

        padding:
            30px 32px 25px;

        border-bottom:
            1px solid
            rgba(
                100,
                100,
                100,
                0.12
            );


        @media (
            max-width:
                560px
        ) {

            padding:
                24px 20px;

        }

    `;


export const TituloFormulario =
    styled.h2`

        margin:
            0;

        color:
            #23AAAF;

        font-size:
            1.55rem;

        line-height:
            1.2;

        font-weight:
            800;

    `;


export const TextoFormulario =
    styled.p`

        margin:
            8px 0 0;

        color:
            #646464;

        font-size:
            0.91rem;

        line-height:
            1.55;

    `;


/*
========================================
FORM
========================================
*/

export const FormularioNuevaCuenta =
    styled.form`

        width:
            100%;

    `;


export const SeccionNuevaCuenta =
    styled.section`

        padding:
            28px 32px;

        border-bottom:
            1px solid
            rgba(
                100,
                100,
                100,
                0.11
            );


        &:last-of-type {

            border-bottom:
                none;

        }


        @media (
            max-width:
                560px
        ) {

            padding:
                24px 20px;

        }

    `;


export const EncabezadoSeccion =
    styled.div`

        margin-bottom:
            20px;

    `;


export const TituloSeccion =
    styled.h3`

        margin:
            0;

        color:
            #23AAAF;

        font-size:
            1rem;

        font-weight:
            800;

    `;


export const TextoSeccion =
    styled.p`

        margin:
            6px 0 0;

        color:
            #646464;

        font-size:
            0.83rem;

        line-height:
            1.5;

    `;


/*
========================================
GRID
========================================
*/

export const GridFormulario =
    styled.div`

        display:
            grid;

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            17px 18px;


        @media (
            max-width:
                650px
        ) {

            grid-template-columns:
                1fr;

        }

    `;


/*
========================================
CAMPO
========================================
*/

export const CampoFormulario =
    styled.div`

        min-width:
            0;

        display:
            flex;

        flex-direction:
            column;

        gap:
            7px;


        ${
            props =>
                props.$completo
                    ?
                    `
                        grid-column:
                            1 / -1;
                    `
                    :
                    ''
        }


        &[data-error="true"] {

            input,
            select {

                border-color:
                    #FC8906;

                background:
                    rgba(
                        252,
                        137,
                        6,
                        0.04
                    );

            }

        }

    `;


export const LabelFormulario =
    styled.label`

        color:
            #646464;

        font-size:
            0.79rem;

        font-weight:
            700;

    `;


export const Obligatorio =
    styled.span`

        margin-left:
            4px;

        color:
            #D76970;

    `;


/*
========================================
INPUT / SELECT
========================================
*/

const campoBase = `

    width:
        100%;

    min-height:
        44px;

    padding:
        10px 12px;

    border:
        1.5px solid
        rgba(
            35,
            170,
            175,
            0.28
        );

    border-radius:
        9px;

    outline:
        none;

    background:
        #FAFCFC;

    color:
        #646464;

    font-family:
        inherit;

    font-size:
        0.9rem;

    transition:
        0.16s ease;

    &:focus {

        border-color:
            #23AAAF;

        background:
            #FFFFFF;

        box-shadow:
            0 0 0 3px
            rgba(
                35,
                170,
                175,
                0.09
            );

    }

    &:disabled {

        opacity:
            0.62;

        cursor:
            not-allowed;

    }

`;


export const InputFormulario =
    styled.input`

        ${campoBase}

    `;


export const SelectFormulario =
    styled.select`

        ${campoBase}

        cursor:
            pointer;

    `;


/*
========================================
PASSWORD
========================================
*/

export const CampoPassword =
    styled.div`

        position:
            relative;

        width:
            100%;


        ${InputFormulario} {

            padding-right:
                68px;

        }

    `;


export const BotonVerPassword =
    styled.button`

        position:
            absolute;

        top:
            50%;

        right:
            10px;

        transform:
            translateY(
                -50%
            );

        padding:
            5px 7px;

        border:
            0;

        background:
            transparent;

        color:
            #655EE8;

        font-size:
            0.74rem;

        font-weight:
            700;

        cursor:
            pointer;

    `;


/*
========================================
ERRORES
========================================
*/

export const TextoError =
    styled.div`

        color:
            #FC8906;

        font-size:
            0.76rem;

        line-height:
            1.35;

        font-weight:
            600;

    `;


/*
========================================
UBICACIÓN
========================================
*/

export const BloqueUbicacion =
    styled.div`

        width:
            100%;

        padding:
            18px;

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.18
            );

        border-radius:
            12px;

        background:
            rgba(
                35,
                170,
                175,
                0.025
            );


        &[data-error="true"] {

            border-color:
                #FC8906;

            background:
                rgba(
                    252,
                    137,
                    6,
                    0.025
                );

        }


        ${TextoError} {

            margin-top:
                10px;

        }


        @media (
            max-width:
                520px
        ) {

            padding:
                14px;

        }

    `;


/*
========================================
REQUISITOS PASSWORD
========================================
*/

export const RequisitosPassword =
    styled.div`

        margin-top:
            15px;

        display:
            flex;

        flex-wrap:
            wrap;

        gap:
            8px;

    `;


export const RequisitoPassword =
    styled.span`

        display:
            inline-flex;

        align-items:
            center;

        min-height:
            28px;

        padding:
            5px 9px;

        border-radius:
            999px;

        background:
            ${
                props =>
                    props.$cumplido
                        ?
                        'rgba(35, 170, 175, 0.10)'
                        :
                        'rgba(100, 100, 100, 0.07)'
            };

        color:
            ${
                props =>
                    props.$cumplido
                        ?
                        '#23AAAF'
                        :
                        '#646464'
            };

        font-size:
            0.72rem;

        font-weight:
            700;

    `;


/*
========================================
TÉRMINOS
========================================
*/

export const FilaTerminos =
    styled.div`

        margin-top:
            24px;

        display:
            flex;

        align-items:
            flex-start;

        gap:
            10px;

        padding:
            13px 14px;

        border:
            1px solid
            rgba(
                100,
                100,
                100,
                0.12
            );

        border-radius:
            10px;

        background:
            #FAFCFC;


        &[data-error="true"] {

            border-color:
                #FC8906;

        }

    `;


export const CheckboxTerminos =
    styled.input`

        width:
            17px;

        height:
            17px;

        flex:
            0 0 auto;

        margin:
            2px 0 0;

        accent-color:
            #23AAAF;

        cursor:
            pointer;

    `;


export const TextoTerminos =
    styled.div`

        color:
            #646464;

        font-size:
            0.8rem;

        line-height:
            1.45;

    `;


/*
========================================
MENSAJE BACKEND
========================================
*/

export const MensajeBackend =
    styled.div`

        margin:
            20px 32px 0;

        padding:
            12px 14px;

        border-radius:
            10px;

        background:
            ${
                props =>
                    props.$error
                        ?
                        'rgba(215, 105, 112, 0.10)'
                        :
                        'rgba(35, 170, 175, 0.10)'
            };

        color:
            ${
                props =>
                    props.$error
                        ?
                        '#D76970'
                        :
                        '#23AAAF'
            };

        font-size:
            0.84rem;

        line-height:
            1.45;

        font-weight:
            650;


        @media (
            max-width:
                560px
        ) {

            margin:
                18px 20px 0;

        }

    `;


/*
========================================
ACCIONES
========================================
*/

export const AccionesFormulario =
    styled.div`

        padding:
            25px 32px 30px;

        display:
            flex;

        justify-content:
            flex-end;


        @media (
            max-width:
                560px
        ) {

            padding:
                22px 20px 26px;

        }

    `;


export const BotonCrearCuenta =
    styled.button`

        min-width:
            165px;

        min-height:
            44px;

        padding:
            10px 22px;

        border:
            none;

        border-radius:
            10px;

        background:
            #FC8906;

        color:
            #FFFFFF;

        font-family:
            inherit;

        font-size:
            0.9rem;

        font-weight:
            800;

        cursor:
            pointer;

        transition:
            0.18s ease;


        &:hover:not(
            :disabled
        ) {

            transform:
                translateY(
                    -1px
                );

            box-shadow:
                0 5px 14px
                rgba(
                    252,
                    137,
                    6,
                    0.22
                );

        }


        &:disabled {

            opacity:
                0.58;

            cursor:
                not-allowed;

        }


        @media (
            max-width:
                520px
        ) {

            width:
                100%;

        }

    `;


export const TextoLoginMobile =
    styled.div`

        display:
            none;

        padding:
            0 20px 28px;

        text-align:
            center;

        color:
            #646464;

        font-size:
            0.82rem;


        a {

            color:
                #655EE8;

            font-weight:
                700;

            text-decoration:
                none;

        }


        @media (
            max-width:
                640px
        ) {

            display:
                block;

        }

    `;